import {
  AvailableProductsOptions,
  AvailableProductsOptions as AISAvailableProductsOptions,
  AvailableProductsLegacyResponse as AISAvailableProductsLegacyResponse,
  AvailableProductsResponse as AISAvailableProductsResponse
} from '@atlassiansox/asc-stargate';
import { AsyncResult, useAsync } from './use-async';
import { useStargateClient } from './use-stargate-client';

export function useAvailableProducts({
  includeInvalidSites,
  includeInvalidBitbucketSite
}: AvailableProductsOptions): AsyncResult<AISAvailableProductsLegacyResponse | null> {
  const stargateClient = useStargateClient();

  return useAsync(
    () =>
      stargateClient.availableProductsLegacy({
        includeInvalidSites,
        includeInvalidBitbucketSite
      }),
    []
  );
}

export function useAISAvailableProducts({
  includeInvalidSites,
  includeInvalidBitbucketSite,
  removeNonAdminSites
}: AISAvailableProductsOptions): AsyncResult<AISAvailableProductsResponse | null> {
  const stargateClient = useStargateClient();

  return useAsync(
    () =>
      stargateClient.availableProducts({
        includeInvalidSites,
        includeInvalidBitbucketSite,
        removeNonAdminSites
      }),
    []
  );
}
